import React, { isValidElement, useMemo } from 'react';
export const useFavorites = ({
  children,
  elements,
  favorites
}) => {
  const favoriteElements = useMemo(() => {
    return elements.filter(element => favorites.includes(element.id)).map(elm => ({
      ...elm,
      filtered: false
    }));
  }, [elements, favorites]);
  const childrenArray = useMemo(() => {
    const reactChildrenArray = React.Children.toArray(children);
    return favoriteElements.map(element => reactChildrenArray.find(reactChild => /*#__PURE__*/isValidElement(reactChild) && (reactChild.key === `.$${element?.id}` || reactChild.key === `.${element?.id}`))).filter(Boolean);
  }, [children, favoriteElements]);
  return {
    reactElements: childrenArray,
    elements: favoriteElements
  };
};